import { Component, Prop, State, Element, Watch, h } from '@stencil/core';
import xss, { whiteList } from 'xss';
import {JsonParser, getTranslation, SlotChangeObserver, hasSlot} from '@ace/web-components/dist_lib/utils';
import {IAceHeadlineTag} from '@ace/web-components';

const DEFAULT_TRANSLATIONS = {
	slot_count_label: 'Slots',
};

@Component({
	tag: 'w2d-shared-jackpot-swiper-section',
	styleUrl: './w2d-shared-jackpot-swiper-section.scss',
	shadow: true,
})
export class W2dSharedJackpotSwiperSection {
	@Prop() headline: string;
	@Prop() headlineTag: IAceHeadlineTag = 'h2';
	@Prop() body: string;
	@Prop() translations: string;
	@Prop() backgroundSrc: string;
	@Prop() loading: boolean = false;

	@State() slotCount: string;

	@Element() private hostElement;

	private _translations: object;
	private cards: Array<HTMLElement>;
	private _loading: boolean = false;
	private swiperEl;
	private observer: MutationObserver;

	componentWillLoad() {
		this.parseTranslations();
		this.parseLoading();
	}

	componentDidLoad() {
		this.loadCardItems();
		// @ts-ignore – for some reason TS complains but this is a fully valid approach.
		this.observer = new SlotChangeObserver(this.hostElement, this.loadCardItems.bind(this));
	}

	disconnectedCallback() {
		this.observer.disconnect();
	}

	@Watch('translations')
	private parseTranslations() {
		this._translations = new JsonParser(this.translations).getValue();
	}

	@Watch('loading')
	private parseLoading() {
		this._loading = this.loading;
	}

	private async loadCardItems() {
		const slotContent = this.hostElement.shadowRoot.querySelector('slot');
		this.cards = slotContent ? slotContent.assignedElements() : [];

		if (!this.cards || !this.cards.length) {
			return;
		}

		this.cards.forEach(item => {
			this.swiperEl.insertAdjacentElement('beforeend', item);
		});

		setTimeout(() => {
			this.swiperEl.getNumberOfCards().then((totalCards) => {
				const slotCountLabel = getTranslation(this._translations, 'slot_count_label', DEFAULT_TRANSLATIONS);
				this.slotCount = totalCards ? `${totalCards.toString()} ${slotCountLabel}` : null;
			});
		}, 100);
	}

	private renderLoaderSlot() {
		if (!hasSlot(this.hostElement, 'loader')) {
			return;
		}

		return <slot name='loader' slot='loader'></slot>;
	}

	private renderSlotCountTag() {
		if(hasSlot(this.hostElement, 'count-tag')) {
			return <slot name='count-tag' slot='headline-tag'></slot>;
		}

		if(this.slotCount) {
			return <ace-tag label={this.slotCount} slot='headline-tag'></ace-tag>;
		}
	}

	render() {
		let headlineColor = 'text-neutral--primary-uni-light';
		let textColor = 'text-neutral--secondary-uni-light';

		if(!this.backgroundSrc) {
			headlineColor = 'text-neutral--primary';
			textColor = 'text-neutral--secondary';
		}

		return (
			<ace-section with-overlay='true' background-src={this.backgroundSrc} class='w2d-shared-jackpot-section'>
				<div class='w2d-shared-jackpot-section__wrapper'>
					<slot></slot>
					<div class='w2d-shared-jackpot-section__teaser'>
						<div class='w2d-shared-jackpot-section__headline'>
							<ace-headline tag={this.headlineTag} type={'h2'} color={headlineColor}>
								{this.headline}
							</ace-headline>
							<ace-text tag={'p'} type={'body'} color={textColor} innerHTML={xss(this.body, {whiteList})}></ace-text>
						</div>
						<slot name='shared-jackpot-counter'></slot>
					</div>
					<ace-swiper dark={true} ref={el => (this.swiperEl = el)} hide-if-empty={false} loading={this._loading}>
						{this.renderSlotCountTag()}
						{this.renderLoaderSlot()}
					</ace-swiper>
				</div>
			</ace-section>
		);
	}
}
